export default __webpack_public_path__ + "static/media/mapty.05b405a1.jpg";